export default __webpack_public_path__ + "static/media/100percent.cc1ad1ec.png";